module.exports = __webpack_public_path__ + "img/2.87975664.png";